import { Injectable, inject } from '@angular/core';
import { Plugin } from '@jeppesen-foreflight/jmkw-types';
import { combineLatest, map, shareReplay } from 'rxjs';
import { TwcButtonComponent } from '../twc-button/twc-button.component';
import { TwcCheckboxesPopoutComponent } from '../twc-button/twc-checkboxes-popout/twc-checkboxes-popout.component';
import { configurePlugin } from '../twc.utils';
import { TwcForecastPluginService } from './forecast/twc-forecast.plugin.service';
import { TwcObservationPluginService } from './observation/twc-observation.plugin.service';
import { TWC_CONFIG_TOKEN, TwcPluginEnvironment } from './twc-config.token';

@Injectable({
  providedIn: 'root'
})
export class TwcPluginService {
  private readonly _env = inject(TWC_CONFIG_TOKEN);
  observationPlugins$ = inject(TwcObservationPluginService).plugin$;
  forecastPlugins$ = inject(TwcForecastPluginService).plugin$;

  weatherPlugin$ = combineLatest([
    this.observationPlugins$,
    this.forecastPlugins$
  ]).pipe(
    map((twcPlugins) => {
      twcPlugins.forEach((plugin) => {
        configurePlugin(plugin);
      });
      return twcPlugins;
    }),
    map(
      (twcPlugins) =>
        new Plugin({
          id: 'twc_weather',
          button: {
            iconName: 'icon-weather',
            tooltipText: 'Weather Channel Options',
            automationKey: 'weather-button',
            buttonComponent: TwcButtonComponent,
            contentComponent: TwcCheckboxesPopoutComponent
          },
          children: twcPlugins
        })
    ),
    shareReplay(1)
  );

  create({ apiKey }: TwcPluginEnvironment) {
    this._env.apiKey = apiKey;
    return this.weatherPlugin$;
  }
}
